import { createStyles } from '@mantine/styles';

var useStyles = createStyles(() => ({
  root: {
    backgroundColor: "transparent",
    cursor: "pointer",
    padding: 0,
    border: 0
  }
}));

export default useStyles;
//# sourceMappingURL=Anchor.styles.js.map
